import {
  ScheduleSettingsSlot,
  Slot,
  Status,
} from "@shared/features/agenda/types/agenda-settings.types";
import { api } from "./common/base";
import { PatientListService } from "./common/patient-list";

export class AssistantService extends PatientListService<any> {
  constructor() {
    super("assistant");
  }

  public updateScheduleSettings({
    settings,
    id,
  }: {
    settings: {
      slots: Array<{
        start: string;
        end: string;
      }>;
      duration: number;
    };
    id?: string;
  }) {
    return api
      .post("/user-schedule/assistant/settings", settings, { params: { id } })
      .then((res) => res.data);
  }

  public getSchedule({ id }) {
    return api.get(`/user-schedule/assistant/${id}`).then((res) => res.data);
  }

  public requestScheduleAccess({ id }) {
    return api
      .get(`/user-schedule/assistant/${id}/request-access`)
      .then((res) => res.data);
  }

  public createScheduleSlots({
    slots,
    id,
  }: {
    slots: Array<{
      start: string;
      end: string;
      status: Status;
    }>;
    id?: string;
  }) {
    console.log(slots);

    return this.api
      .post(`../user-schedule/assistant`, slots, { params: { id } })
      .then((res) => res.data);
  }

  public deleteScheduleSlots({
    slotIds,
    id,
  }: {
    slotIds: string[];
    id?: string;
  }) {
    return this.api
      .delete(`../user-schedule/assistant/slots`, {
        params: { id },
        data: { slotIds },
      })
      .then((res) => res.data);
  }
}
